import axiosInstance from './axiosConfig';
import { ApiResponse } from './generalService';

export type RunStatus = 'running' | 'done' | 'failed' | 'interrupted';
export type BookingOutcome = 'created' | 'skipped' | 'failed';
export type VisitStep =
  | 'resolve_template'
  | 'stage_patient_form'
  | 'create_visit'
  | 'write_visit_journal';

export interface BookingResult {
  bookingId: string;
  patientId?: string;
  userId?: string;
  userMissing?: boolean;
  outcome: BookingOutcome;
  staged: boolean;
  step?: VisitStep;
  cause?: 'webdoc' | 'missing_data' | 'unknown' | 'expected';
  reason?: string;
  statusCode?: number;
  visitId?: string;
}

export interface RunSummary {
  runId: string;
  status: RunStatus;
  date: string;
  trigger: 'cron' | 'manual';
  dryRun: boolean;
  total: number;
  processed: number;
  created: number;
  staged: number;
  skipped: number;
  failed: number;
  startedAt: string;
  heartbeat: string;
  finishedAt?: string;
}

export interface RunState extends RunSummary {
  results: BookingResult[];
}

export interface StartRunRequest {
  date?: string;
  bookingIds?: string[];
  force?: boolean;
  confirm?: 'RUN';
}

export interface StartRunResponse {
  runId: string;
  date: string;
  dryRun: boolean;
}

export const startVisitRun = (body: StartRunRequest) =>
  axiosInstance.post<ApiResponse<StartRunResponse>>(
    '/visits/admin/create-todays',
    body
  );

export const getVisitRun = (runId: string) =>
  axiosInstance.get<ApiResponse<RunState>>(`/visits/admin/runs/${runId}`);

export const listVisitRuns = (limit = 10) =>
  axiosInstance.get<ApiResponse<{ runs: RunSummary[] }>>(
    `/visits/admin/runs?limit=${limit}`
  );
